import { ArrowRight, InboxIcon } from 'assets/icons';
import useHomeText from 'hooks/useHomeText';
import { CARD_CLASS } from 'utils/surfaceClasses';

// Where the card leads: the prospects tab, filtered on the inbound ones
// nobody owns yet (CompaniesPage reads these parameters on mount).
export const DEMO_REQUESTS_TARGET = '/company?tab=prospects&unassigned=1';

/**
 * The demo requests of the website waiting for a sales rep, on the manager's
 * home page. The api sends `demoRequestsToAssign` to the 500 only: without a
 * positive count, there is nothing to show.
 */
const DemoRequestsCard = ({ count, onOpen }) => {
  const { text } = useHomeText();
  if (typeof count !== 'number' || count <= 0) return null;

  return (
    <button
      type="button"
      onClick={onOpen}
      className={`flex shrink-0 items-center gap-2.5 py-3 pl-4 pr-3 text-left transition-colors hover:bg-gray-50 ${CARD_CLASS}`}
    >
      <span className="flex size-8 shrink-0 items-center justify-center rounded-lg bg-blue-50 text-blue-700">
        <InboxIcon wh={18} color="currentColor" />
      </span>
      <span className="min-w-0 flex-1">
        <span className="block text-sm font-semibold text-gray-900">
          {text(count === 1 ? 'demoRequests.countOne' : 'demoRequests.countMany', { count })}
        </span>
        <span className="block text-xs text-gray-500">{text('demoRequests.hint')}</span>
      </span>
      <ArrowRight wh={18} color="currentColor" />
    </button>
  );
};

export default DemoRequestsCard;
